export default {
    consent :{
        getByApproval : '/customerConsent/get-by-approval',
        requestConsentByEmail : '/customerConsent/request-consent-by-email',
        resendConsentByEmail : '/customerConsent/resend-consent-by-email',
        requestConsentByPdf : '/customerConsent/request-consent-by-pdf',
        resendConsentByPdf : '/customerConsent/resend-consent-by-pdf',
        validate : '/customerConsent/validate-consent',
        submitPdfConsentForm: '/customerConsent/submit-pdf-consent-form',
        getById: '/customerConsent/get-by-id',
        adminSearch: '/customerConsent/admin-search',
        adminResetEmailLimit: '/customerConsent/admin-reset-email-limit'
    },
    meterCommission :{
        createMeterCommissionProcess: '/meter-commission/create-meter-commission-process',
        getMeterCommissionSiteRegistration:'/meter-commission/get-meter-commission-site-registration',
        getMeterCommissionLidRegistration:'/meter-commission/get-meter-commission-lid-registration',
        saveMeterCommissionSiteRegistration:'/meter-commission/save-meter-commission-site-registration',
        submitSiteRegistration:'/meter-commission/submit-site-registration',
        rejectMeterRegistration:'/meter-commission/reject-meter-registration',
        approveMeterRegistration:'/meter-commission/approve-meter-registration',
        getMeterCommissionValidation:'/meter-commission/get-meter-commission-validation',
        saveMeterCommissionValidation:'/meter-commission/save-meter-commission-validation',
        triggerMeterCommissioning:'/meter-commission/trigger-meter-commissioning',
        submitMeterCommissionValidation:'/meter-commission/submit-meter-commission-validation',
        getMeterCommissionForAssigningOfficer:'/meter-commission/get-meter-commission-for-assigning-officer',
        assignApprovingOfficer:'/meter-commission/assign-approving-officer',
        adminToggleAwaitingResolution:'/meter-commission/admin-toggle-awaiting-resolution',
        rejectMeterValidation:'/meter-commission/reject-meter-validation',
        approveMeterValidation:'/meter-commission/approve-meter-validation',
        deleteDraft:'/meter-commission/delete-draft',
        adminTransferDqp:'/meter-commission/admin-transfer-dqp',
        adminTransferDqpConsentCheck:'/meter-commission/admin-transfer-dqp-consent-check',
        adminDelete:'/meter-commission/admin-delete-meter-commission',
        adminResendLidVendorLink:'/meter-commission/admin-resend-lid-vendor-link',
        validateReadyForInstallationDAS:'/meter-commission/validate-ready-for-installation-das',
        getAuditsById:'/meter-commission/get-audits-by-id',
        saveNotes:'/meter-commission/save-notes',
        changeLidVendorLidRegistration:'/meter-commission/change-lid-vendor-lid-registration',
        adminResolveWasCdoConfirmedFailure:'/meter-commission/admin-resolve-was-cdo-confirmed-failure',
        adminNotifyWasCdoConfirmed:'/meter-commission/admin-notify-was-cdo-confimred',
        adminResolveDasWorkspaceCreation:'/meter-commission/admin-resolve-das-workspace-creation',
        adminRetriggerDASWorkspaceCreation:'/meter-commission/admin-retrigger-das-workspace-creation',
        adminResolveMeterDecommissionFailure:'/meter-commission/admin-resolve-meter-decommission-failure',
        adminRetriggerMeterDecommission:'/meter-commission/admin-retrigger-meter-decommission',
        getMeterCommissionLidRegistrationForVendor:'/meter-commission/get-meter-commission-lid-registration-for-vendor',
        acceptLidRegistrationForVendor: '/meter-commission/accept-lid-registration-for-vendor',
        submitLidRegistrationForVendor: '/meter-commission/submit-lid-registration-for-vendor',
        rejectLidRegistrationToDQP: '/meter-commission/reject-lid-registration-to-dqp',
        adminValCertGenerated : '/meter-commission/admin-val-cert-generated',
        adminValCertRegenerate : '/meter-commission/admin-val-cert-regenerate',
        getSimActivations : '/meter-commission/get-meter-commission-sim-activations',
        adminModifySim:'/meter-commission/admin-modify-sim',
        adminRevertSim:'/meter-commission/admin-revert-sim'
    },
    meterFormCommon : {
        getWorksAndMetersByWorksiteId:'/meterFormCommon/get-works-and-meters-by-worksite-id',
        getLidOptions:'/meterFormCommon/get-lids-options',
        getLidOptionsAndSimCardOptionsForVendor:'/meterFormCommon/get-lids-options-and-sim-card-options-for-vendor',
        getExistingLidsForApproval:'/meterFormCommon/get-existing-lids-for-approval',
        getExistingLidsForApprovalForVendor:'/meterFormCommon/get-existing-lids-for-approval-for-vendor',
        
    },
    meterSiteAuditForm : {
        createMeterSiteAuditForm:'/site-audit/create-meter-site-audit-form',
        getSiteAuditForm:'/site-audit/get-site-audit-form',
        saveSiteAuditForm:'/site-audit/save-site-audit-form',
        submitSiteAuditForm:'/site-audit/submit-site-audit-form',
        getSiteAuditFormsForAssigningOfficer:'/site-audit/get-site-audit-forms-for-assigning-officer',
        assignApprovingOfficer:'/site-audit/assign-approving-officer',
        rejectMeterSiteAuditForm:'/site-audit/reject-meter-site-audit-form',
        approveMeterSiteAuditForm:'/site-audit/approve-meter-site-audit-form',
    },
    admin : {
        searchMeter : '/admin/search-meters',
        getMeter: '/admin/get-meter',
        getMeterAndIntegration : '/admin/get-meter-and-meter-integration',
        getMeterIntegrationDetails: '/admin/get-meter-integration-details',
        initialiseMeterIntegration: '/admin/initialise-meter-integration',
        startMeterIntegrationDetails: '/admin/start-meter-integration-details',
        toggleMeterIntegrationStatus: '/admin/toggle-meter-integration-status',
        matchEagleIoIntegrationForMeter: '/admin/match-eagle-io-integration-for-meter',
        matchWasIntegrationForMeter: '/admin/match-was-integration-for-meter',
        searchForms: '/admin/search-forms-new',
        exportForms: '/admin/export-forms-new',
        bulkTransferForms: '/admin/bulk-transfer-forms',
        getUserAudits:'/admin/get-user-audits',
        deleteMeter:'/admin/delete-meter',
        decommissionMeter:'/admin/decommission-meter',
        getAllGenericReferenceData : '/admin/get-all-reference-data',
        deleteGenericReferenceData : '/admin/delete-reference-data',
        addGenericReferenceData : '/admin/add-reference-data',
        editGenericReferenceData : '/admin/edit-reference-data',
        getAllLidVendors : '/admin/get-all-lid-vendors',
        saveLidVendor : '/admin/save-lid-vendor',
        getAllLidForAdminUpdate : '/admin/get-all-lids-for-admin-update',
        saveLidVendorForLid : '/admin/save-lid-vendor-for-lid',
        saveMeterTypeForLid : '/admin/save-meter-type-for-lid',
        sageMeterLidManufacturerForLid : '/admin/save-meter-lid-manufacturer-for-lid',
        getAllMeterModels : '/admin/get-all-meter-models',
        saveMeterModel : '/admin/save-meter-model',
        saveRatingTable:'/admin/save-rating-table',
        searchRatingTables:'/admin/search-rating-tables',
        getAllMeterCategoriesFromWAS:'/admin/get-all-meter-categories-from-was',
        searchSimCards:'/admin/search-sim-cards',
        getSimCardDetails:'/admin/get-sim-card-details',
        updateSimCardStatus:'/admin/update-sim-card-status',
        updateSimCardLabel:'/admin/update-sim-card-label',
        udpateSimCardLidVendor:'/admin/update-sim-card-lid-vendor',
        addSimCardNotes:'/admin/add-sim-card-notes',
    },
    meter : {
        getMeterByApprovalNumber : '/meter/get-meters-by-approval-number',
        adminEditMeter:'/meter/admin-edit-meter',
        adminEditMeterSave:'/meter/admin-edit-meter-save',
        getEditMeterDetails:'/meter/get-edit-meter-details',
    },
    das : {
        requestWorkspaceAccess : '/das/request-workspace-access',
        getMyDasAccessRequests : '/das/get-my-das-access-requests'
    },
    others : {
        homeSearch : '/others/home-search',
        searchUsers : '/others/search-users',
        initContactForm : '/others/init-contact-form',
        contactFormFindExistingForm : '/others/contact-form-find-existing-form',
        getContactFormOptions : '/others/get-contact-form-options',
        submitContactForm : '/others/submit-contact-form',
        
    },
    ratingTables : {
        searchByRoiOrStorageWorkApproval:'/ratingTables/searchByRoiOrStorageWorkApproval'
    },
    simManagement: {
        activationProcessMarkAsCompleted : '/sim-management/activation-process-mark-as-completed',
        activationProcessRetrySimActivation : '/sim-management/activation-process-retry-sim-activation',
        activationProcessRetryUpdateToDas : '/sim-management/activation-process-retry-update-to-das',
        activationProcessRetryIpReterieval : '/sim-management/activation-process-retry-ip-retrieval',
        getProcessDetails : '/sim-management/get-process-details',
        getCurrentProcessDetialsForMeterCommission : '/sim-management/get-current-process-details-for-meter-commission',
        restartActivationProcessForMeterCommission:'/sim-management/restart-sim-activation-for-meter-commission'
    }
    
}

